(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name itecAdministracio.api.persona.factory:PersonaFactory
   *
   * @description
   *
   */
  angular
    .module('itecAdministracio.api.tema')
    .factory('TemaFactory', TemaFactory);

  function TemaFactory(AdmConstant, DataFactory) {
    var api = AdmConstant.SERVER_PATH_ADMINISTRACIO + 'temes';
    
    var TemaBase = {
      gettemesvistesarrel: function(idrol){
        var url = api +'/temesvistesarrel' ;
        return DataFactory.getWithParams(url, {"idrol":idrol});
      },        
      getfills: function(id,idrol){
        var url = api + '/' + id + '/fills';
        return DataFactory.getWithParams(url, {"idrol":idrol});
      },
      getobjectes: function(id,idrol){
        var url = api + '/' + id + '/objectes';
        return DataFactory.getWithParams(url, {"idrol":idrol});
      }/*,
      getacls: function(id,idrol,idvistaobjecte){
        var url = api + '/' + id + '/acls';
        return DataFactory.getWithParams(url, {"idrol":idrol,"idvistaobjecte":idvistaobjecte});
      }  */       
    };
    return TemaBase;
  }
}());
